var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { State, Action, Selector, createSelector } from '@ngxs/store';
import { EngineCameraStateModel } from './engine.camera.state.model';
import { StoreCamera, ClearCamera, MoveCamera, ZoomCamera, PanCameraX, RotateCameraX, PanCameraY, RotateCameraY, SetCameraMode, SetZoomed, LockCamera, ResetCamera } from './engine.camera.actions';
import { CameraService } from '../../camera.service';
import { CameraMotionModel } from '../../models/camera-motion.model';
import { tap } from 'rxjs/operators';
var engineCameraStateDefaults = {
    storedCameras: {},
    cameraMotion: new CameraMotionModel(),
    panMode: 'rotate',
    zoomed: false,
    lockCamera: false
};
var EngineCameraState = /** @class */ (function () {
    function EngineCameraState(cameraService) {
        this.cameraService = cameraService;
    }
    EngineCameraState_1 = EngineCameraState;
    /**
     * Selectors
     */
    EngineCameraState.getStoredCamera = function (id) {
        return createSelector([EngineCameraState_1], function (state) {
            return state.storedCameras[id] || null;
        });
    };
    EngineCameraState.getCameraMotion = function (state) {
        return state.cameraMotion;
    };
    EngineCameraState.getPanMode = function (state) {
        return state.panMode;
    };
    EngineCameraState.getZoomed = function (state) {
        return state.zoomed;
    };
    EngineCameraState.getLockCamera = function (state) {
        return state.lockCamera;
    };
    /**
     * Actions
     */
    EngineCameraState.prototype.storeCamera = function (context, action) {
        var camera = action.camera || this.cameraService.getCamera();
        var storedCameras = context.getState().storedCameras;
        storedCameras[action.id] = __assign({}, camera);
        context.patchState({
            storedCameras: __assign({}, storedCameras)
        });
    };
    EngineCameraState.prototype.clearCamera = function (context, action) {
        var storedCameras = context.getState().storedCameras;
        delete storedCameras[action.id];
        context.patchState({
            storedCameras: __assign({}, storedCameras)
        });
    };
    EngineCameraState.prototype.moveCamera = function (context, action) {
        context.patchState({
            cameraMotion: __assign({}, action.cameraMotion)
        });
    };
    EngineCameraState.prototype.resetCamera = function (context, action) {
        return this.cameraService.resetCamera().pipe(tap(function () {
            context.patchState({
                cameraMotion: new CameraMotionModel()
            });
        }));
    };
    EngineCameraState.prototype.zoomCamera = function (context, action) {
        var cameraMotion = context.getState().cameraMotion;
        cameraMotion.zoom = action.value;
        context.patchState({
            cameraMotion: __assign({}, cameraMotion)
        });
    };
    EngineCameraState.prototype.panCameraX = function (context, action) {
        var cameraMotion = context.getState().cameraMotion;
        cameraMotion.panX = action.value;
        context.patchState({
            cameraMotion: __assign({}, cameraMotion)
        });
    };
    EngineCameraState.prototype.panCameraY = function (context, action) {
        var cameraMotion = context.getState().cameraMotion;
        cameraMotion.panY = action.value;
        context.patchState({
            cameraMotion: __assign({}, cameraMotion)
        });
    };
    EngineCameraState.prototype.rotateCameraX = function (context, action) {
        var cameraMotion = context.getState().cameraMotion;
        // cameraMotion.rotateX = action.value;
        context.patchState({
            cameraMotion: __assign({}, cameraMotion, { rotateX: action.value })
        });
    };
    EngineCameraState.prototype.rotateCameraY = function (context, action) {
        var cameraMotion = context.getState().cameraMotion;
        cameraMotion.rotateY = action.value;
        context.patchState({
            cameraMotion: __assign({}, cameraMotion)
        });
    };
    EngineCameraState.prototype.SetCameraMode = function (context, action) {
        context.patchState({
            panMode: action.mode
        });
    };
    EngineCameraState.prototype.setZoomed = function (context, action) {
        context.patchState({
            zoomed: action.zoomed
        });
    };
    EngineCameraState.prototype.lockCamera = function (context, action) {
        context.patchState({
            lockCamera: action.lock
        });
    };
    var EngineCameraState_1;
    __decorate([
        Action(StoreCamera),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, StoreCamera]),
        __metadata("design:returntype", void 0)
    ], EngineCameraState.prototype, "storeCamera", null);
    __decorate([
        Action(ClearCamera),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, ClearCamera]),
        __metadata("design:returntype", void 0)
    ], EngineCameraState.prototype, "clearCamera", null);
    __decorate([
        Action(MoveCamera),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, MoveCamera]),
        __metadata("design:returntype", void 0)
    ], EngineCameraState.prototype, "moveCamera", null);
    __decorate([
        Action(ResetCamera),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, ResetCamera]),
        __metadata("design:returntype", void 0)
    ], EngineCameraState.prototype, "resetCamera", null);
    __decorate([
        Action(ZoomCamera),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, ZoomCamera]),
        __metadata("design:returntype", void 0)
    ], EngineCameraState.prototype, "zoomCamera", null);
    __decorate([
        Action(PanCameraX),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, PanCameraX]),
        __metadata("design:returntype", void 0)
    ], EngineCameraState.prototype, "panCameraX", null);
    __decorate([
        Action(PanCameraY),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, PanCameraY]),
        __metadata("design:returntype", void 0)
    ], EngineCameraState.prototype, "panCameraY", null);
    __decorate([
        Action(RotateCameraX),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, RotateCameraX]),
        __metadata("design:returntype", void 0)
    ], EngineCameraState.prototype, "rotateCameraX", null);
    __decorate([
        Action(RotateCameraY),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, RotateCameraY]),
        __metadata("design:returntype", void 0)
    ], EngineCameraState.prototype, "rotateCameraY", null);
    __decorate([
        Action(SetCameraMode),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SetCameraMode]),
        __metadata("design:returntype", void 0)
    ], EngineCameraState.prototype, "SetCameraMode", null);
    __decorate([
        Action(SetZoomed),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SetZoomed]),
        __metadata("design:returntype", void 0)
    ], EngineCameraState.prototype, "setZoomed", null);
    __decorate([
        Action(LockCamera),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, LockCamera]),
        __metadata("design:returntype", void 0)
    ], EngineCameraState.prototype, "lockCamera", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [EngineCameraStateModel]),
        __metadata("design:returntype", void 0)
    ], EngineCameraState, "getCameraMotion", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [EngineCameraStateModel]),
        __metadata("design:returntype", void 0)
    ], EngineCameraState, "getPanMode", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [EngineCameraStateModel]),
        __metadata("design:returntype", void 0)
    ], EngineCameraState, "getZoomed", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [EngineCameraStateModel]),
        __metadata("design:returntype", void 0)
    ], EngineCameraState, "getLockCamera", null);
    EngineCameraState = EngineCameraState_1 = __decorate([
        State({
            name: 'engineCamera',
            defaults: engineCameraStateDefaults
        }),
        __metadata("design:paramtypes", [CameraService])
    ], EngineCameraState);
    return EngineCameraState;
}());
export { EngineCameraState };
